import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="category-grid" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-label font-medium mb-4">
            Product Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-3">
            Browse Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Explore our organized Sugargoo Spreadsheet database across 14 shopping categories. Find exactly what you need, faster.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/50 transition-all cursor-pointer"
            >
              <div className="aspect-[4/3] w-full overflow-hidden bg-background-200">
                <img
                  src={cat.imageUrl}
                  alt={`Sugargoo Spreadsheet ${cat.name} category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center bg-accent-100 rounded-md flex-shrink-0">
                    <i className={`${cat.icon} text-accent-600 text-sm`}></i>
                  </div>
                  <span className="text-sm font-label font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                    {cat.name}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm font-label font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            Sugargoo Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}